import toastr from 'toastr';
import StringMask from 'string-mask';

export default {
  /*função para arredondar numero para cima*/
  arredondar(val, casas_decimais) {
    let multiplicador = 1;
    for (let i = 0; i < casas_decimais; i++) {
        multiplicador = multiplicador * 10;
    }
    return Math.round(val * multiplicador) / multiplicador;
  },
  
  /*função para verificar padrão de cpf e cnpj*/
  cpfCnpjOk(registro) {
    let cpf_cnpj = registro.toString();
    // Remove caracteres invá¡lidos do valor
    cpf_cnpj = cpf_cnpj.replace(/[^0-9]/g, "");
    // Verifica CPF
    if (cpf_cnpj.length === 11) {
      return true;
    } else if (cpf_cnpj.length === 14) {
      return true;
    } else {
      return false;
    }
  },
  
  verificarErro(erro, nome_funcao) {
    this.gerarLogNomeFuncao('FrameClienteOrcamento.vue -> ' + nome_funcao);
    let mensagem = this.tratamentoMensagem(erro);
    this.exclamar(mensagem);
  },
  
  /* função para quebrar nomes grandes*/
  reduzirNome(texto, limite) {
    let ultimo;
    if (texto.length > limite) {
      limite--;
      ultimo = texto.substr(limite - 1, 1);
      while (ultimo != " " && limite > 0) {
        limite--;
        ultimo = texto.substr(limite - 1, 1);
      }
      ultimo = texto.substr(limite - 2, 1);
      if (ultimo == "," || ultimo == ";" || ultimo == ":") {
        texto = texto.substr(0, limite - 2) + "...";
      } else if (ultimo == "." || ultimo == "?" || ultimo == "!") {
        texto = texto.substr(0, limite - 1);
      } else {
        texto = texto.substr(0, limite - 1) + "...";
      }
    }
    return texto;
  },
  
  /* testa data string */
  dataOk(data_str) {
    if ((data_str == undefined) || (data_str == '')) {
      return false;
    }
    let retorno = false;
    let confere = this.toStrdata(data_str);
    let confere2 = (confere.getDate() < 10 ? '0' : '') + confere.getDate();
    confere2 += '/' + ((confere.getMonth() + 1) < 10 ? '0' : '') + (confere.getMonth() + 1);
    confere2 += '/' + confere.getFullYear();
    retorno = (confere2 == data_str);
    return retorno;
  },
  
  /* string para data*/
  toStrdata(data_entrada) {
    let data_1 = Date.parse(data_entrada)
    let data = new Date(data_1)
    typeof(data)
    return data
  },
  
  /* data para string DD/MM/AAAA */
  toDataStr(data_str) {
    let retorno = this.fDataHoras(data_str, "DD/MM/AAAA")
    return retorno;
  },
  
  /*de string para data e hora DD/MM/AAAA hh:mm:ss*/
  toStrdataTime(data_entrada) {
    let data_1 = Date.parse(data_entrada)
    let data = new Date(data_1)
    typeof(data)
    let ano = data.getFullYear(0);
    let mes = data.getMonth() + 1;
    let dia = data.getDate();
    let hora = data.getHours();
    let minutos = data.getMinutes();
    let segundos = data.getSeconds();
    let hora_formatada = hora % 12 || 12;
    return new Date(dia + "/" + mes + "/" + ano + " " + hora + ":" + minutos + ":" + segundos)
  },
  
  /*de string para data e hora DD/MM/AAAA hh:mm:ss*/
  toStrdata(data_entrada) {
    let data_1 = Date.parse(data_entrada)
    let data = new Date(data_1)
    typeof(data)
    let ano = data.getFullYear(0);
    let mes = data.getMonth() + 1;
    let dia = data.getDate();
    let hora = data.getHours();
    let minutos = data.getMinutes();
    let segundos = data.getSeconds();
    let hora_formatada = hora % 12 || 12;
    return new Date(dia + "/" + mes + "/" + ano)
  },
  
  /* função para retornar decode de um vetor ex "DF, Brasilia" entra DF sai Brasilia*/
  decode(base, vetor) {
    let retorno;
    let i;
    for (i in vetor) {
      if (base == vetor[i]) {
        i++
        retorno = vetor[i]
        return retorno
      } else {
        if (vetor.length % 2 == 0) {
          retorno = vetor[i]
        } else {
          retorno = ''
        }
      }
    }
    return retorno
  },
  
  /*verifica se a base informada existe no vetor*/
  em(base, vetor) {
    let retorno = false;
    let i;
    for (i in vetor) {
      if (base == vetor[i]) {
        retorno = true
      }
    }
    return retorno
  },
  
  /*coloca data no formato da mascara*/
  fDataHoras(data_entrada) {
    let data_1 = Date.parse(data_entrada)
    let data = new Date(data_1)
    typeof(data)
    let ano = data.getFullYear(0);
    let mes = data.getMonth() + 1;
    let dia = data.getDate();
    let hour = data.getHours();
    let minutos = data.getMinutes();
    let segundos = data.getSeconds();
    let hora_formatada = hour % 12 || 12;
    let minuto_formatado = minutos < 10 ? "0" + minutos : minutos;
    //periodo_do_dia = hour < 12 ? "am" : "pm";
    if (dia < 10) {
      dia = "0" + dia
    }
    if (mes < 10) {
      return dia + "/0" + mes + "/" + ano + " " + hora_formatada + ":" + minuto_formatado + ":" + segundos;
    } else {
      return dia + "/" + mes + "/" + ano + " " + hora_formatada + ":" + minuto_formatado + ":" + segundos;
    }
  },
  
  /* coloca data no formato da mascara */
  fData(data) {
    if (!data){
      return;
    }

    let data_date = this.strToDate(data);
    if (!data_date) {
      return '';
    }

    let dia = data_date.getDate();
    if (dia < 10) {
      dia = '0' + dia;
    }
    
    let mes = data_date.getMonth() + 1;
    if (mes < 10) {
      mes = '0' + mes;
    }

    let ano = data_date.getFullYear();

    return dia + '/' + mes + '/' + ano;
  },

  fDataInternacional(data) {
    let data_date = this.strToDate(data);
    if (!data_date) {
      return '';
    }

    let dia = data_date.getDate();
    if (dia < 10) {
      dia = '0' + dia;
    }
    
    let mes = data_date.getMonth() + 1;
    if (mes < 10) {
      mes = '0' + mes;
    }

    let ano = data_date.getFullYear();

    return ano + '-' + mes + '-' + dia;
  },
  
  
  /* retorna valores no padrão de casas decimais*/
  nPadrao(numero, casas_decimais = 2) {
    if (numero == undefined) {
      numero = 0;
    }

    if (!isNaN(numero)) {
      if (casas_decimais == 0) {
        numero = this.valorInt(numero);
      }
      else {
        numero = this.valor(numero);
      }
    }

    return numero.toLocaleString(
      'pt-BR', 
      {
        minimumFractionDigits: casas_decimais,
        maximumFractionDigits: casas_decimais
      }
    );
  },

  nPadraoReais(numero, casas_decimais = 2) {
    return 'R$ ' + this.nPadrao(numero, casas_decimais);
  },

  nPadraoPercentual(numero, casas_decimais = 2) {
    return this.nPadrao(numero, casas_decimais) + '%';
  },
  
  /*Receber boolean e retornar a string Sim ou Não*/
  simNao(confirma) {
    return confirma ? 'Sim' : 'Não'
  },
  
  /*Receber 'S' ou 'N' e retornar Sim ou Não*/
  simNaoString(sn) {
    if (sn == 'S') {
      return 'Sim';
    }
    else if (sn == 'N') {
      return 'Não';
    }
  },

  /* Converte string em data, seja formato internacional ou br */
  strToDate(data) {
    try { 

      if ((!data) || (data == '')) {
        return undefined;
      }

      if (data instanceof Date) {
        return new Date(data);
      }

      if (data.length < 8) {
        return undefined;
      }

      let caractere;
      if (data.indexOf('/') > 0) {
        caractere = '/';
      }
      else if (data.indexOf('-') > 0) {
        caractere = '-';
      }

      if (!caractere) {
        return undefined;
      }

      let vetor = data.substr(0, 10).split(caractere);
      if (vetor.length != 3) {
        return undefined;
      }

      let dia;
      let mes;
      let ano;
      if (vetor[0].length == 4) {
        /* Format internacional */
        ano = vetor[0];
        mes = vetor[1] -1;
        dia = vetor[2];
      }
      else {
        /* Format br */
        ano = vetor[2];
        mes = vetor[1] -1;
        dia = vetor[0];
      }

      let retorno = new Date(ano, mes, dia);
      if (retorno instanceof Date) {
        return retorno;
      }

      return undefined;
    }
    catch(e) {
      return undefined;
    }
  },

  diferencaDias(dataHora1, dataHora2) {
    let dt1 = this.strToDateTime(dataHora1);
    let dt2 = this.strToDateTime(dataHora2);

    if ((!dt1) || (!dt2)) {
      return 0;
    }

    let milissegundos_dia = 1000 * 60 * 60 * 24;
    let intervalo_milissegundos = dt2.getTime() - dt1.getTime();
    let dias = intervalo_milissegundos / milissegundos_dia;

    // Arredonda para baixo a diferença de dias
    return Math.floor(dias);
  },

  diferencaHoras(dataHora1, dataHora2) {
    let dt1 = this.strToDateTime(dataHora1);
    let dt2 = this.strToDateTime(dataHora2);

    if ((!dt1) || (!dt2)) {
      return 0;
    }

    let milissegundos_hora = 1000 * 60 * 60;
    let intervalo_milissegundos = dt2.getTime() - dt1.getTime();
    let dias = intervalo_milissegundos / milissegundos_hora;

    // Arredonda para baixo a diferença de dias
    return Math.floor(dias);
  },

  strToDateTime(data_hora_str) {
    try {
      if (!data_hora_str) {
        return undefined;
      }

      let data_hora = new Date(data_hora_str);

      /* - Se for uma data/hora (que não requer confirmação); ou */
      /* - Se for uma data/hora no formato yyyy-MM-ddTHH:mm:ss   */

      if ((data_hora !== 'Invalid Date') && (!isNaN(new Date(data_hora)))) {
        return data_hora;
      }
      
      /* - Se for o formato dd/MM/yyyy hh:mm:ss */
      let teste = '' + data_hora_str;

      if (
        (teste.length >= 19) &&
        (teste.charAt(2) == '/') &&
        (teste.charAt(5) == '/') &&
        (teste.charAt(13) == ':') &&
        (teste.charAt(16) == ':')
      ) {
        let dia = teste.substring(0, 2);
        let mes = teste.substring(3, 5);
        let ano = teste.substring(6, 10);
        let horas = teste.substring(11, 13);
        let minutos = teste.substring(14, 16);
        let segundos = teste.substring(17, 19);

        teste = (
          ano + '-' + mes + '-' + dia + 
          'T' + horas + ':' + minutos + ':' + segundos
        );

        data_hora = new Date(teste);

        if ((data_hora !== "Invalid Date") && (!isNaN(new Date(data_hora)))) {
          return data_hora;
        }
      }

      return undefined;
    }
    catch(e) {
      return undefined;
    }
  },
  
  /*verifica se um periodo entre datas é valido */
  validarPeriodo(data_inicial, data_final) {
    let data_inicial_date = this.strToDate(data_inicial);
    let data_final_date  = this.strToDate(data_final);
    
    if (!data_inicial_date) {
      toastr.error('Data inicial inválida!');
      return false;
    }

    if (!data_final_date) {
      toastr.error('Data final inválida!');
      return false;
    }

    if (data_inicial_date > data_final_date) {
      toastr.error('A data inicial não pode ser maior que a data final!');
      return false;
    }
    
    return true;
  },

  stringVazia(texto) {
    if ((!texto) || (texto == '') || (texto.trim() == '')) {
      return true;
    }

    return false;
  },
  
  /* REMOVER ESTA FUNÇÃO ASSIM QUE POSSÍVEL. SUBSTITUIR POR numeros(string) */
  apenasNumeros(string) {
    let apenas_numeros = string.replace(/[^0-9]/g, '');
    return apenas_numeros;
  },

  numeros(string) {
    let sentenca = '' + string; /* Caso já seja um número */
    return sentenca.replace(/[^0-9]/g, '');
  },

  /*função recebe numero string e converte para float*/
  valor(numero_str, casas_decimais = -1) {
    try {

      if (Number(numero_str) === numero_str){
        return numero_str;
      }

      var aux = numero_str;
      let pos_virgula = numero_str.indexOf(",");
      let pos_ponto = numero_str.indexOf(".");

      if (pos_ponto > pos_virgula) {
        /* Significa que o separador decimal é o ponto - padrão internacional */
        aux = aux.split(',').join('');
        aux = parseFloat(aux);
      }
      else {
        /* Significa que o separador decimal é a vírgula - padrão BR */
        aux = aux.split('.').join('');
        aux = aux.replace(',', '.');
        aux = parseFloat(aux);
      }

      if (casas_decimais >= 0) {
        aux = aux.toFixed(casas_decimais);
      }

      return Number(aux);
    }
    catch(e) {
      return 0;
    }
  },

  /* função recebe numero string e converte para int */
  valorInt(numero_str) {
    let nr = numero_str;
    try {
      if ((nr == undefined) || (nr == '')) {
        return 0;
      }

      if (Number.isInteger(nr)) {
        nr = Math.trunc(nr).toString();
      }

      let aux = nr.split('.').join('');
      return parseInt(aux);
    }
    catch(e) {
      return 0;
    }
  },
  
  /* função para retirar acentos*/
  retiraAcentos(newStringComAcento) {
    let string = newStringComAcento;
    let mapaAcentosHex = {
      a: /[\xE0-\xE6]/g,
      e: /[\xE8-\xEB]/g,
      i: /[\xEC-\xEF]/g,
      o: /[\xF2-\xF6]/g,
      u: /[\xF9-\xFC]/g,
      c: /\xE7/g,
      n: /\xF1/g
    };
  
    for (let letra in mapaAcentosHex) {
      let expressaoRegular = mapaAcentosHex[letra];
      string = string.replace(expressaoRegular, letra);
    }
    return string;
  },

  /* Recebe um texto e um vetor de caracteres. Remove as ocorrencias dos caracteres do texto */
  retirarCaracteres(texto, caracteres) {
    try {
      let retorno = texto;
      for (let i = 0; i < caracteres.length; i++) {
        retorno = retorno.split(caracteres[i]).join('');
      }

      return retorno;
    }
    catch(e) {
      return texto;
    }
  },
  
  /* função substitui numero por mês*/
  nomeMes(numero) {
    if (numero == 1) {
      return "Janeiro"
    }
    if (numero == 2) {
      return "Fevereiro"
    }
    if (numero == 3) {
      return "Março"
    }
    if (numero == 4) {
      return "Abril"
    }
    if (numero == 5) {
      return "Maio"
    }
    if (numero == 6) {
      return "Junho"
    }
    if (numero == 7) {
      return "Julho"
    }
    if (numero == 8) {
      return "Agosto"
    }
    if (numero == 9) {
      return "Setembro"
    }
    if (numero == 10) {
      return "Outubro"
    }
    if (numero == 11) {
      return "Novembro"
    }
    if (numero == 12) {
      return "Dezembro"
    } else {
      return toastr.info("Mês não encontrado")
    }
  },

  gerarLogNomeFuncao(nome_funcao){
    if (!nome_funcao) {
      return;
    }

    console.log('Função: ', nome_funcao);
  },

  imagemToBase64(img) {
    // Criando canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    // Atribuindo width e height
    canvas.width = img.width;
    canvas.height = img.height;
    // Desenhe a imagem
    ctx.drawImage(img, 0, 0);
    return canvas.toDataURL('image/jpeg');
  },

  retornoRequisicao(houve_erro, mensagem, dados) {
    mensagem = this.tratamentoMensagem(mensagem)
    return {
      houve_erro: houve_erro,
      mensagem: mensagem,
      dados: dados
    }
  },

  tratamentoMensagem(web_erro){
    let retorno = ''   

    if (!web_erro){
      return retorno
    }

    try {
      if (web_erro.message == 'TIMEOUT'){
        retorno = 'Tempo de requisição expirado! Por favor verifique sua conexão com a internet e tente novamente.';
      }
      else if (web_erro.message == 'SEM_CONEXAO'){
        retorno = 'Sem conexão com a internet no momento! Por favor verifique sua conexão com a internet e tente novamente.';
      }
      else if (web_erro.status == 401){
        retorno = 'Usuário não autorizado.';       
      }
      else if (web_erro.mensagem){
        retorno = web_erro.mensagem;
      } else {
        retorno = web_erro.message;
      }
    } catch (e) {
      retorno = web_erro.message;
    }

    return retorno.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));;
  },
  
  exclamar(mensagem){
    if (mensagem){
      mensagem = mensagem.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
    }

    if (mensagem == 'É necessário realizar o login para concluir esta operação!'){
      return;
    }

    toastr.error(mensagem, 'Atenção');
    console.log('Mensagem:', mensagem);
  },

  informar(mensagem){
    if (mensagem){
      mensagem = mensagem.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
    }

    if (mensagem == 'É necessário realizar o login para concluir esta operação!'){
      return;
    }
    
    toastr.info(mensagem, 'Sucesso');
    console.log('Mensagem:', mensagem);
  },

  corAzulVermelho(valor, inverter_cor){
    if (!valor){
      return 'color: #00000050;';
    }

    valor = valor.toUpperCase();

    if ((valor == 'S') || (valor == 'SIM')){
      return inverter_cor ? 'color: #b33030;' : 'color: #175aa6;';
    }
    else {
      return inverter_cor ? 'color: #175aa6;' : 'color: #b33030;';
    }
  },

  booleanToChar(valor) {
    if (valor) {
      return 'S';
    }
    else {
      return 'N';
    }
  },

  validarEMail(email, aceita_vazio) {
    if (!email) {
      return aceita_vazio;
    }

    if (email.length == 0) {
      return aceita_vazio;
    }

    email = '' + email;

    if (email.toLowerCase() != email) {
      return false;
    }

    let qtd_arroba = 0;
    for (let i = 0; i < email.length; i++) {
      if (email.charAt(i) == '@') {
        qtd_arroba++;
      }
    }

    if (qtd_arroba != 1) {
      return false;
    }


    if (email.indexOf('.') == -1) {
      return false;
    }

    let usuario = '' + email.substring(0, email.indexOf('@'));
    if (usuario.length == 0) {
      return false;
    }

    let dominio = '' + email.substring(email.indexOf('@') + 1, email.length);
    if (dominio.length == 0) {
      return false;
    }

    if (dominio.indexOf('.') == -1) {
      return false;
    }

    return true;
  },

  aplicarMascara(numeros, mascara) {
    var formatter = new StringMask(mascara, {reverse: true});
    return formatter.apply(numeros);
  },

  aplicarMascaraTelefone(numeros, e_0800) {
    let num = this.numeros(numeros);

    if (!num) {
      return numeros;
    }

    let mascara = undefined;
    if (num.length == 10) {
      mascara = '(00) 0000-0000';

      if (e_0800) {
        mascara = '0000-00-0000';
      }
    }
    else if (num.length == 11) {
      mascara = '(00) 00000-0000';

      if (e_0800) {
        mascara = '0000-000-0000';
      }
    }

    if (!mascara) {
      return numeros;
    }

    return this.aplicarMascara(num, mascara);
  },

  buscarNomeNavegador() {
    try {
      let eOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
      
      if (eOpera) {
        return 'Opera';
      }

      let eFirefox = typeof InstallTrigger !== 'undefined'; // Firefox 1.0+
      if (eFirefox) {
        return 'Firefox';
      }

      let eChrome = !!window.chrome && !eOpera; // Chrome 1+
      if (eChrome) {
        return 'Chrome';
      }

      let eSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
      if (eSafari) {
        return 'Safari';
      }
      
      let eInternetExplorer = /*@cc_on!@*/false || !!document.documentMode; //IE6 ou superior
      if (eInternetExplorer) {
        return 'Internet Explorer';
      }
      
      return 'Indefinido';
    } catch (error) {
      return 'Indefinido';
    }
  },

  buscarSistemaOperacionalDispositivo() {
    try {
      if (navigator.userAgent.indexOf("Windows NT 10.0") != -1) {
        return "Windows 10";
      }
  
      if (navigator.userAgent.indexOf("Windows NT 6.2") != -1) {
        return "Windows 8";
      }
  
      if (navigator.userAgent.indexOf("Windows NT 6.1") != -1) {
        return "Windows 7";
      }
  
      if (navigator.userAgent.indexOf("Windows NT 6.0") != -1) {
        return "Windows Vista";
      }
  
      if (navigator.userAgent.indexOf("Windows NT 5.1") != -1) {
        return "Windows XP";
      }
  
      if (navigator.userAgent.indexOf("Windows NT 5.0") != -1) {
        return "Windows 2000";
      }
  
      if (navigator.userAgent.indexOf("Mac") != -1) {
        return "Mac/iOS";
      }
  
      if (navigator.userAgent.indexOf("X11") != -1) {
        return "UNIX";
      }
  
      if (navigator.userAgent.indexOf("Linux") != -1) {
        return "Android/Linux";
      }

      return 'Indefinido';
    } catch (error) {
      return 'Indefinido';
    }
  },

  buscarTipoRedeDispositivo() {
    try {
      return ('' + navigator.connection.effectiveType).toUpperCase(); 
    } catch (error) {
      return 'Indefinido';
    }
  },

  buscarStatusRedeDispositivo() {
    try {
      return navigator.onLine;
    } catch (error) {
      return true;
    }
  },

  buscarModoEconomiaDadosDispositivo() {
    try {
      return navigator.connection.saveData; 
    } catch (error) {
      return false;
    }
  },

  buscarDadosDispositivo() {
    try {
      return navigator.userAgent; 
    } catch (error) {
      return 'Indefinido';
    }
  },

  buscarVelocidadeDownloadDispositivo(somente_velocidade) {
    try {
      // Caso seja necessário alterar alguma coisa aqui rever todos os pontos no servidor que utiliza --> (Mb/s ou mb/s) <---
      if ((navigator.connection) && (navigator.connection.downlink)) {
        if (somente_velocidade){
          return navigator.connection.downlink;
        } else {
          return navigator.connection.downlink + ' Mb/s';
        }
      } else {
        return 'Indefinida';
      } 
    } catch (error) {
      return 'Indefinida';
    }
  },

  buscarDadosLatenciaDispositivo() {
    try {
      if (navigator.connection.rtt) {
        return navigator.connection.rtt + ' ms';
      }
      else {
        return 'Indefinida';
      }
    } catch (error) {
      return 'Indefinida';
    }
  },

  buscarMemoriaRamDispositivo() {
    try {
      return navigator.deviceMemory; 
    } catch (error) {
      return 0;
    }
  },

  buscarGeolocalizacaoDispositivo() {
    try {
      return navigator.geolocation; 
    } catch (error) {
      return 'Indefinida';
    }
  },

  buscarPlataformaDispositivo() {
    try {
      return navigator.platform; 
    } catch (error) {
      return 'Indefinida';
    }
  },

  buscarAplicativoVersaoDispositivo() {
    try {
      return navigator.appVersion; 
    } catch (error) {
      return 'Indefinida';
    }
  },

  buscarTipoConexaoDispositivo() {
    try {
      return navigator.connection.type; 
    } catch (error) {
      return 'Indefinida';
    }
  }


}


// WEBPACK FOOTER //
// ./src/components/Repositorio/Biblioteca.js